export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      dialogMixinDialogVisible: this.visible
    }
  },
  watch: {
    dialogMixinDialogVisible(value) {
      this.$emit("update:visible", value);
    },
    visible(value) {
      this.dialogMixinDialogVisible = value
    },
  },
  methods: {
    $DialogMixinOnClose() {
      this.dialogMixinDialogVisible = false
    }
  },
}
